// Scoped styles for the Property Intelligence report viewer. Everything is
// under .pi-report / .pi-report-modal so no global styling changes. Colors
// match StrategyCreditConfirmModal (NAVY, BLUE, LIGHT_BLUE_BG/BORDER).

export const PI_REPORT_CSS = `
/* Semantic pins fullscreen modals to left:0; this one is centered in the dimmer. */
.ui.modal.pi-report-modal { position: relative !important; left: auto !important; top: auto !important; width: min(1200px, calc(100vw - 32px)) !important; margin: auto !important; border-radius: 14px !important; overflow: hidden; }
.ui.modal.pi-report-modal > i.close.icon, .ui.modal.pi-report-modal > .close { display: none !important; }
.pi-report-modal.ui.modal > .content { padding: 0 !important; border-radius: 14px; }
@media (max-width: 767px) { .pi-report-modal.ui.modal { width: calc(100vw - 16px) !important; } }

.pi-report { --pi-navy: #16243c; --pi-blue: #2185d0; --pi-blue-bg: #eaf4fc; --pi-blue-border: #cfe4f7;
  --pi-border: #e3e8ef; --pi-bg: #f5f7fa; --pi-text: #2b3440; --pi-muted: #667085;
  display: flex; flex-direction: column; height: min(940px, calc(100vh - 48px)); background: #fff; color: var(--pi-text); font-size: 15px; line-height: 1.5; }
@media (max-width: 767px) { .pi-report { height: calc(100vh - 16px); font-size: 15px; } }

/* ---- header ---- */
.pi-head { flex-shrink: 0; padding: 16px 24px 0; background: #fff; border-bottom: 1px solid var(--pi-border); }
.pi-brand { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.pi-brand img { height: 50px; width: auto; }
.pi-eyebrow { color: var(--pi-muted); font-size: 12.5px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; }
.pi-close { margin-left: auto; width: 36px; height: 36px; border-radius: 8px; border: 1px solid transparent; background: transparent; color: var(--pi-muted); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
.pi-close:hover, .pi-close:focus-visible { background: var(--pi-bg); border-color: var(--pi-border); color: var(--pi-navy); outline: none; }
.pi-close i.icon { margin: 0; font-size: 1.15em; }
.pi-prop { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; row-gap: 12px; }
.pi-thumb { width: 112px; height: 80px; object-fit: cover; border-radius: 10px; flex-shrink: 0; background: var(--pi-bg); }
.pi-address { min-width: 220px; flex: 1 1 0; }
.pi-address h2 { margin: 0; color: var(--pi-navy); font-size: 24px; font-weight: 800; line-height: 1.2; overflow-wrap: anywhere; }
.pi-address .pi-city { color: var(--pi-muted); margin-top: 2px; }
.pi-meta { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; margin-top: 6px; }
.pi-meta .pi-date { color: var(--pi-muted); font-size: 13px; }
.pi-actions { display: flex; gap: 8px; flex-wrap: wrap; justify-content: flex-end; flex: 0 1 auto; }
.pi-actions .ui.button { margin: 0; }
.pi-tabs { display: flex; justify-content: space-between; margin-top: 14px; }
.pi-tab { appearance: none; background: none; border: none; border-bottom: 3px solid transparent; padding: 10px 8px 9px; color: #4b5563; font-weight: 600; font-size: 14.5px; cursor: pointer; white-space: nowrap; display: inline-flex; align-items: center; gap: 6px; }
.pi-tab i.icon { margin: 0; opacity: 0.85; }
.pi-tab:hover { color: var(--pi-navy); }
.pi-tab:focus-visible { outline: 2px solid var(--pi-blue-border); outline-offset: -2px; border-radius: 6px 6px 0 0; }
.pi-tab.active { color: var(--pi-blue); border-bottom-color: var(--pi-blue); }
.pi-tab-select { margin: 12px 0 14px; width: 100%; }
.pi-tab-select select { width: 100%; padding: 10px 12px; border: 1px solid var(--pi-border); border-radius: 8px; font-size: 15px; color: var(--pi-navy); font-weight: 600; background: #fff; }
@media (max-width: 1260px) { .pi-tab { font-size: 14px; padding: 10px 6px 9px; } }
@media (max-width: 1120px) { .pi-tab i.icon { display: none; } }
@media (max-width: 767px) {
  .pi-head { padding: 12px 14px 0; }
  .pi-thumb { width: 76px; height: 58px; }
  .pi-address h2 { font-size: 20px; }
  .pi-actions { width: 100%; flex-direction: column; margin-left: 0; }
  .pi-actions .ui.button { width: 100%; }
  /* Full Report and Client Summary are in the section menu on phones. */
  .pi-actions .pi-secondary-action { display: none; }
  .pi-brand { margin-bottom: 10px; }
}

/* ---- body ---- */
.pi-body { flex: 1; overflow-y: auto; overflow-x: hidden; background: var(--pi-bg); padding: 20px 24px 28px; }
@media (max-width: 767px) { .pi-body { padding: 14px 12px 20px; } }
.pi-grid-2 { display: grid; grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr); gap: 16px; align-items: start; }
.pi-grid-even { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; align-items: start; }
.pi-col { display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.pi-stack { display: flex; flex-direction: column; gap: 16px; }
@media (max-width: 960px) { .pi-grid-2, .pi-grid-even { grid-template-columns: minmax(0, 1fr); } }

.pi-card { background: #fff; border: 1px solid var(--pi-border); border-radius: 12px; padding: 18px 20px; min-width: 0; }
@media (max-width: 767px) { .pi-card { padding: 14px; } }
.pi-card-title { display: flex; align-items: center; gap: 10px; color: var(--pi-navy); font-weight: 700; font-size: 17px; margin: 0 0 12px; }
.pi-card-title i.icon { color: var(--pi-blue); margin: 0; }
.pi-card-title .pi-count { color: var(--pi-muted); font-weight: 600; font-size: 14px; }
.pi-card-title .pi-right { margin-left: auto; }
.pi-sub { color: var(--pi-muted); font-size: 13.5px; margin: -6px 0 12px; }
.pi-p { line-height: 1.65; margin: 0 0 12px; }
.pi-p:last-child { margin-bottom: 0; }
.pi-muted { color: var(--pi-muted); }
.pi-small { font-size: 13.5px; }
.pi-note { display: flex; gap: 10px; align-items: flex-start; background: var(--pi-blue-bg); border: 1px solid var(--pi-blue-border); border-radius: 10px; padding: 10px 14px; color: var(--pi-navy); font-size: 14px; }
.pi-note i.icon { color: var(--pi-blue); margin: 2px 0 0; }
.pi-note.neutral { background: #f8fafc; border-color: var(--pi-border); color: var(--pi-text); }
.pi-link { color: var(--pi-blue); font-weight: 600; cursor: pointer; background: none; border: none; padding: 0; font-size: inherit; }
.pi-link:hover { text-decoration: underline; }
.pi-link.pi-small { font-size: 13.5px; }
.pi-link i.icon { margin: 0 0 0 3px; font-size: 0.85em; }
.pi-empty { color: var(--pi-muted); font-style: italic; margin: 4px 0; }
.pi-section-heading { color: var(--pi-navy); font-weight: 700; font-size: 18px; margin: 4px 0 0; }

/* ---- badges & chips ---- */
.pi-badge { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; border-radius: 999px; padding: 2px 10px; font-size: 12.5px; font-weight: 600; border: 1px solid; line-height: 1.6; }
.pi-badge.positive { background: #ecf8f0; color: #1d7a43; border-color: #c8ead5; }
.pi-badge.warning { background: #fff2e8; color: #b45309; border-color: #fdd9b5; }
.pi-badge.caution { background: #fff8e6; color: #8a6100; border-color: #f3e0a8; }
.pi-badge.info { background: var(--pi-blue-bg); color: #1a6fb0; border-color: var(--pi-blue-border); }
.pi-badge.neutral { background: #f2f4f7; color: #5b6575; border-color: #e4e7ec; }
.pi-chip { display: inline-flex; align-items: center; gap: 4px; max-width: 100%; border-radius: 6px; padding: 1px 8px; font-size: 12.5px; background: #f2f4f7; color: #475467; border: 1px solid #e4e7ec; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; vertical-align: middle; }
.pi-chip.agent { background: #f4f0ff; color: #5b3fb3; border-color: #e2d9fb; }
.pi-chip.county { background: #ecf8f0; color: #1d7a43; border-color: #c8ead5; }
.pi-chip.mls { background: var(--pi-blue-bg); color: #1a6fb0; border-color: var(--pi-blue-border); }
.pi-sources { display: flex; flex-wrap: wrap; gap: 6px 10px; margin-top: 8px; font-size: 13px; align-items: center; }
.pi-sources a { color: var(--pi-blue); font-weight: 600; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pi-sources a i.icon { margin: 0 0 0 3px; font-size: 0.8em; }
.pi-sources .pi-tier { color: var(--pi-muted); font-size: 12px; }

/* ---- rows ---- */
.pi-row { display: grid; grid-template-columns: 40px minmax(0, 1fr) auto; gap: 12px; align-items: start; padding: 12px 0; border-top: 1px solid #eef1f5; }
.pi-row:first-of-type { border-top: none; padding-top: 2px; }
.pi-row-icon { width: 40px; height: 40px; border-radius: 10px; background: var(--pi-blue-bg); color: var(--pi-blue); display: flex; align-items: center; justify-content: center; }
.pi-row-icon i.icon { margin: 0; }
.pi-row-icon.warning { background: #fff2e8; color: #c2410c; }
.pi-row-icon.caution { background: #fff8e6; color: #a16207; }
.pi-row-icon.positive { background: #ecf8f0; color: #1d7a43; }
.pi-row-title { color: var(--pi-navy); font-weight: 700; }
.pi-row-text { color: #475467; font-size: 14px; margin-top: 2px; }
.pi-row-side { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.pi-expander { appearance: none; border: none; background: none; color: var(--pi-muted); cursor: pointer; padding: 2px 4px; border-radius: 6px; }
.pi-expander:hover, .pi-expander:focus-visible { color: var(--pi-navy); background: var(--pi-bg); outline: none; }
.pi-expander i.icon { margin: 0; }
.pi-detail { grid-column: 2 / -1; background: #f8fafc; border: 1px solid #eef1f5; border-radius: 10px; padding: 10px 12px; font-size: 14px; }
.pi-detail p { margin: 0 0 6px; }
.pi-detail p:last-child { margin: 0; }
@media (max-width: 640px) {
  .pi-row { grid-template-columns: 34px minmax(0, 1fr); }
  .pi-row-icon { width: 34px; height: 34px; }
  .pi-row-side { grid-column: 2; flex-direction: row; align-items: center; justify-content: space-between; }
  .pi-detail { grid-column: 1 / -1; }
}

/* ---- glance tiles ---- */
.pi-tiles { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
.pi-tile { display: flex; gap: 10px; align-items: center; border: 1px solid #eef1f5; border-radius: 10px; padding: 10px 12px; min-width: 0; }
.pi-tile i.icon { color: #8a94a6; margin: 0; font-size: 1.2em; flex-shrink: 0; }
.pi-tile-label { color: var(--pi-muted); font-size: 12.5px; }
.pi-tile-value { color: var(--pi-navy); font-weight: 700; overflow-wrap: anywhere; }
@media (max-width: 420px) { .pi-tiles { grid-template-columns: minmax(0, 1fr); } }

/* ---- key/value lists ---- */
.pi-kv { width: 100%; border-collapse: collapse; }
.pi-kv td { padding: 8px 0; border-top: 1px solid #eef1f5; vertical-align: top; }
.pi-kv tr:first-child td { border-top: none; }
.pi-kv td.k { color: var(--pi-muted); width: 42%; padding-right: 12px; font-size: 14px; }
.pi-kv td.v { color: var(--pi-navy); font-weight: 600; overflow-wrap: anywhere; }
.pi-kv td.s { text-align: right; white-space: nowrap; padding-left: 8px; }
.pi-kv tr.clickable { cursor: pointer; }
.pi-kv tr.clickable:hover td { background: #fafbfc; }
@media (max-width: 520px) { .pi-kv td.s { display: none; } }

/* ---- steps ---- */
.pi-steps { list-style: none; margin: 0; padding: 0; }
.pi-steps li { display: flex; gap: 10px; align-items: flex-start; padding: 8px 0; border-top: 1px solid #eef1f5; }
.pi-steps li:first-child { border-top: none; padding-top: 0; }
.pi-steps li i.icon { color: var(--pi-blue); margin: 2px 0 0; }
.pi-steps .pi-step-title { color: var(--pi-navy); font-weight: 600; }
.pi-steps .pi-step-why { color: var(--pi-muted); font-size: 13.5px; }
.pi-steps li.done .pi-step-title { text-decoration: line-through; color: var(--pi-muted); }

/* ---- tables ---- */
.pi-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.pi-table th { text-align: left; color: var(--pi-muted); font-weight: 600; font-size: 12.5px; text-transform: uppercase; letter-spacing: 0.04em; padding: 8px 10px; border-bottom: 1px solid var(--pi-border); }
.pi-table td { padding: 10px; border-bottom: 1px solid #eef1f5; vertical-align: top; overflow-wrap: anywhere; }
.pi-table tr:last-child td { border-bottom: none; }
@media (max-width: 700px) {
  .pi-table thead { display: none; }
  .pi-table tr { display: block; padding: 10px 0; border-bottom: 1px solid #eef1f5; }
  .pi-table td { display: block; border: none; padding: 2px 0; }
  .pi-table td[data-label]::before { content: attr(data-label); display: block; color: var(--pi-muted); font-size: 12px; font-weight: 600; }
}

/* ---- timeline ---- */
.pi-timeline { position: relative; margin: 0; padding: 0 0 0 22px; list-style: none; }
.pi-timeline::before { content: ""; position: absolute; left: 6px; top: 6px; bottom: 6px; width: 2px; background: #e4e9f0; }
.pi-timeline li { position: relative; padding: 0 0 16px; }
.pi-timeline li::before { content: ""; position: absolute; left: -21px; top: 5px; width: 12px; height: 12px; border-radius: 50%; background: #fff; border: 3px solid var(--pi-blue); }
.pi-timeline li.minor::before { border-color: #b8c2d0; }
.pi-timeline .pi-when { color: var(--pi-muted); font-size: 13px; font-weight: 600; }

/* ---- risk cards ---- */
.pi-risk { display: grid; grid-template-columns: 48px minmax(0, 1fr) minmax(150px, 210px); gap: 16px; }
.pi-risk .pi-row-icon { width: 48px; height: 48px; font-size: 1.2em; }
.pi-risk-side { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; text-align: right; }
.pi-risk-side a { font-size: 13px; font-weight: 600; color: var(--pi-blue); }
.pi-risk h4 { margin: 0; color: var(--pi-navy); font-size: 16.5px; }
.pi-risk .pi-headline { font-weight: 600; color: var(--pi-text); margin: 4px 0 6px; }
.pi-label { font-weight: 700; color: var(--pi-navy); }
@media (max-width: 760px) {
  .pi-risk { grid-template-columns: 40px minmax(0, 1fr); }
  .pi-risk .pi-row-icon { width: 40px; height: 40px; }
  .pi-risk-side { grid-column: 1 / -1; align-items: flex-start; text-align: left; flex-direction: row; flex-wrap: wrap; }
}

/* ---- amenity cards ---- */
.pi-amenities { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px; }
.pi-amenity { display: flex; gap: 12px; border: 1px solid #eef1f5; border-radius: 10px; padding: 12px; min-width: 0; }
.pi-amenity-art { width: 64px; height: 64px; border-radius: 10px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #e8f3fc, #d7ebf9); color: var(--pi-blue); font-size: 1.4em; }
.pi-amenity-art i.icon { margin: 0; }
.pi-amenity-art.park, .pi-amenity-art.trail { background: linear-gradient(135deg, #eaf7ee, #d4efdc); color: #2f855a; }

/* ---- full report ---- */
.pi-reader { display: grid; grid-template-columns: 220px minmax(0, 1fr); gap: 24px; align-items: start; }
.pi-toc { position: sticky; top: 0; background: #fff; border: 1px solid var(--pi-border); border-radius: 12px; padding: 12px; max-height: calc(100vh - 260px); overflow-y: auto; }
.pi-toc button { display: block; width: 100%; text-align: left; background: none; border: none; padding: 6px 8px; border-radius: 6px; color: #475467; font-size: 13.5px; cursor: pointer; }
.pi-toc button:hover, .pi-toc button:focus-visible { background: var(--pi-bg); color: var(--pi-navy); outline: none; }
.pi-article { background: #fff; border: 1px solid var(--pi-border); border-radius: 12px; padding: 28px 36px; min-width: 0; }
.pi-article h3 { color: var(--pi-navy); font-size: 19px; margin: 28px 0 10px; padding-bottom: 6px; border-bottom: 2px solid #e8eef6; display: flex; align-items: center; gap: 10px; }
.pi-article h3:first-of-type { margin-top: 0; }
.pi-article p { line-height: 1.75; margin: 0 0 14px; font-size: 15.5px; }
.pi-ref { font-size: 11px; vertical-align: super; color: var(--pi-blue); font-weight: 700; margin-left: 2px; cursor: pointer; background: none; border: none; padding: 0; }
@media (max-width: 960px) { .pi-reader { grid-template-columns: minmax(0, 1fr); } .pi-toc { display: none; } }
@media (max-width: 767px) { .pi-article { padding: 16px; } }

.pi-disclosure { border-top: 1px dashed var(--pi-border); margin-top: 10px; padding-top: 8px; }
.pi-disclosure > button { font-size: 13.5px; }
`;
